import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleFAQAction = createAsyncThunk(
    'get-single-FAQ',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/support-knowladge/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleFAQSlice = createSlice({
    name: 'get-single-FAQ',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleFAQAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleFAQAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleFAQAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleFAQReducer = getSingleFAQSlice.reducer    